export type PadMap = {
  jump: number;
  attack: number;
  block: number;
  throw: number;
  pause: number;
};

export const DEFAULT_MAP: PadMap = {
  jump: PAD_BINDINGS.jump[0].button,
  attack: PAD_BINDINGS.attack[0].button,
  block: PAD_BINDINGS.block[0].button,
  throw: PAD_BINDINGS.throw[0].button,
  pause: PAD_BINDINGS.pause[0].button,
};

export function loadMaps(): Record<string, PadMap> {
  try {
    return JSON.parse(localStorage.getItem('floppy-clash.padmaps') ?? '{}') as Record<
      string,
      PadMap
    >;
  } catch {
    return {};
  }
}

export function saveMap(padId: string, map: PadMap): void {
  const all = loadMaps();
  all[padId] = map;
  localStorage.setItem('floppy-clash.padmaps', JSON.stringify(all));
}
import { PAD_BINDINGS } from './bindings';
